import { c as _c } from "react/compiler-runtime";
// @ts-nocheck
import { Percent, CurrencyUSD, Time, GraphQLDecimal } from '@/graphql/scalars';
import * as Types from '../../../../types/schema';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BalanceSheetConfigurationPopper_BalanceSheetViewConfigurationFragment = {
  __typename?: 'BalanceSheetViewConfiguration';
  id: string;
  separateInEstateDirectlyHeld: boolean;
  separateInEstateTrusts: boolean;
  separateOutOfEstateTrusts: boolean;
  showInEstate: boolean;
  showOutOfEstate: boolean;
  hideSmallValues: boolean;
  showSummaryMetrics: boolean;
  showExpandedAssetCategories: boolean;
  includeDeathBenefitInTotals: boolean;
};
export type UpdateBalanceSheetViewConfigurationMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateBalanceSheetViewConfigurationInput;
}>;
export type UpdateBalanceSheetViewConfigurationMutation = {
  __typename?: 'Mutation';
  updateBalanceSheetViewConfiguration: ({
    __typename?: 'BalanceSheetViewConfiguration';
  } & BalanceSheetConfigurationPopper_BalanceSheetViewConfigurationFragment);
};
export const Operations = {
  Mutation: {
    UpdateBalanceSheetViewConfiguration: 'UpdateBalanceSheetViewConfiguration' as const
  },
  Fragment: {
    BalanceSheetConfigurationPopper_BalanceSheetViewConfiguration: 'BalanceSheetConfigurationPopper_BalanceSheetViewConfiguration' as const
  }
};

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy
    }
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options
  };
}
export const BalanceSheetConfigurationPopper_BalanceSheetViewConfigurationFragmentDoc = gql`
    fragment BalanceSheetConfigurationPopper_BalanceSheetViewConfiguration on BalanceSheetViewConfiguration {
  id
  separateInEstateDirectlyHeld
  separateInEstateTrusts
  separateOutOfEstateTrusts
  showInEstate
  showOutOfEstate
  hideSmallValues
  showSummaryMetrics
  showExpandedAssetCategories
  includeDeathBenefitInTotals
}
    `;
export const UpdateBalanceSheetViewConfigurationDocument = gql`
    mutation UpdateBalanceSheetViewConfiguration($input: AugmentedUpdateBalanceSheetViewConfigurationInput!) {
  updateBalanceSheetViewConfiguration(input: $input) {
    ...BalanceSheetConfigurationPopper_BalanceSheetViewConfiguration
  }
}
    ${BalanceSheetConfigurationPopper_BalanceSheetViewConfigurationFragmentDoc}`;
export type UpdateBalanceSheetViewConfigurationMutationFn = Apollo.MutationFunction<UpdateBalanceSheetViewConfigurationMutation, UpdateBalanceSheetViewConfigurationMutationVariables>;

/**
 * __useUpdateBalanceSheetViewConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateBalanceSheetViewConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBalanceSheetViewConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBalanceSheetViewConfigurationMutation, { data, loading, error }] = useUpdateBalanceSheetViewConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBalanceSheetViewConfigurationMutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(UpdateBalanceSheetViewConfigurationDocument, options);
}
export type UpdateBalanceSheetViewConfigurationMutationHookResult = ReturnType<typeof useUpdateBalanceSheetViewConfigurationMutation>;
export type UpdateBalanceSheetViewConfigurationMutationResult = Apollo.MutationResult<UpdateBalanceSheetViewConfigurationMutation>;
export type UpdateBalanceSheetViewConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateBalanceSheetViewConfigurationMutation, UpdateBalanceSheetViewConfigurationMutationVariables>;